import { JSON_PATH_SEPARATOR, JSON_PATH_TYPE_SEPARATOR } from './const';
const CUSTOM_ATTRIBUTES_BASE_ATTRIBUTE = 'customAttributes';
export function buildCustomAttributeJsonPath(key, cast) {
    return `${CUSTOM_ATTRIBUTES_BASE_ATTRIBUTE}${JSON_PATH_SEPARATOR}${key}${cast}`;
}
/**
 * Inverse of `buildCustomAttributeJsonPath`: splits `<base>.<key><cast>` into its key and cast, or
 * `null` for any other attribute. A key can never contain `::`, so the split is unambiguous.
 */
export function parseCustomAttributeJsonPath(path) {
    const prefix = `${CUSTOM_ATTRIBUTES_BASE_ATTRIBUTE}${JSON_PATH_SEPARATOR}`;
    if (!path.startsWith(prefix)) {
        return null;
    }
    const rest = path.slice(prefix.length);
    const castIndex = rest.indexOf(JSON_PATH_TYPE_SEPARATOR);
    return castIndex === -1
        ? { key: rest, cast: '' }
        : { key: rest.slice(0, castIndex), cast: rest.slice(castIndex) };
}
